<div class="dialog"
     (pointerdown)="onBackdropPointerDown($event)"
     (pointerup)="onBackdropPointerUp($event)"
     (pointercancel)="onBackdropPointerCancel($event)"
     (click)="onBackdropClick($event)">
    <div class="dialog-card" role="dialog" (click)="$event.stopPropagation()">
        <div class="dialog-header">
            <div class="header-text">{{ subtitle() }}</div>
            @if (!hideIcon()) {
                <div class="close-icon" role="button"
                     (click)="closeDialog();$event.stopPropagation()">
                    <img ngSrc="/assets/img/icons/cancel.svg"
                         priority="true"
                         width="10" height="10" alt=""/>
                </div>
            }
        </div>
        <div class="dialog-content">
            <ng-content></ng-content>
        </div>
    </div>
</div>
